<template>
  <FormPart
      :Item="TicketItem"
      :setItemForm="setItemForm"
      :submitData="submitData"
      @onSuccess="onSuccess"
      @onFail="onFail"
  >
    <template
        v-slot:default="{
          errors,
          ItemForm,
          submit
        }"
    >
      <v-row>
        <v-col
            cols="12"
        >
          <v-checkbox
              v-model="ItemForm.invoicingAutoCalculate"
              :error-messages="errors.invoicingAutoCalculate"
              :dense="true"
              hide-details="auto"
              label="Automatický výpočet"
              @change="submit"
          />
        </v-col>

        <template
            v-if="!ItemForm.invoicingAutoCalculate"
        >
          <v-col
              cols="12"
              lg="4"
          >
            <v-text-field
                v-model="ItemForm.invoicingQuantity"
                :error-messages="errors.invoicingQuantity"
                :filled="true"
                :dense="true"
                hide-details="auto"
                label="Množstvo"
                type="number"
                suffix="x"
                @change="submit"
            />
          </v-col>

          <v-col
              cols="12"
              lg="4"
          >
            <v-text-field
                v-model="ItemForm.invoicingIncrease"
                :error-messages="errors.invoicingIncrease"
                :filled="true"
                :dense="true"
                hide-details="auto"
                label="Prirážka"
                type="number"
                suffix="€"
                @change="submit"
            />
          </v-col>
        </template>

        <v-col
            cols="12"
        >
          <v-textarea
              v-model="ItemForm.invoicingDescription"
              :error-messages="errors.invoicingDescription"
              :filled="true"
              :dense="true"
              hide-details="auto"
              label="Popis"
              :rows="5"
              @change="submit"
          />
        </v-col>
      </v-row>
    </template>
  </FormPart>
</template>

<script>
  import TicketItems from '@/services/ticket-items'

  import FormPart from '@/components/_Part/Form'

  export default {
    name: 'FormInvoicing',
    props: [
      'TicketItem'
    ],
    emits: [
      'refresh'
    ],
    components: {
      FormPart
    },
    methods: {
      setItemForm(Item) {
        return {
          invoicingAutoCalculate: Item.invoicingAutoCalculate,
          invoicingQuantity: Item.invoicingQuantity,
          invoicingIncrease: Item.invoicingIncrease,
          invoicingDescription: Item.invoicingDescription
        }
      },
      submitData(ItemForm) {
        return TicketItems
          .updateInvoicing({
            id: this.TicketItem.id,
            data: ItemForm
          })
      },
      onSuccess() {
        this.$emit('refresh')
      },
      onFail() {
        this.$router.push('/ticket/' + this.TicketItem.Ticket.id)
      }
    }
  }
</script>
